// Age from a date of birth, worked out on the screen from the date itself.
// Accepts a dayjs object, a Date, or a string as "DD-MM-YYYY", "DD/MM/YYYY" or "YYYY-MM-DD" (a time part is ignored).

const toParts = (value) => {
  if (!value) return null;
  if (typeof value === "object" && typeof value.year === "function" && typeof value.isValid === "function") {
    return value.isValid() ? { y: value.year(), m: value.month() + 1, d: value.date() } : null;
  }
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : { y: value.getFullYear(), m: value.getMonth() + 1, d: value.getDate() };
  }
  const s = String(value).trim();
  let m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return { y: +m[1], m: +m[2], d: +m[3] };
  m = s.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
  if (m) return { y: +m[3], m: +m[2], d: +m[1] };
  return null;
};

/** "26 yrs", or "8 mo" under a year; "" when the date is missing, unreadable or in the future. */
export const formatAge = (value, now = new Date()) => {
  const p = toParts(value);
  if (!p || p.m < 1 || p.m > 12 || p.d < 1 || p.d > 31) return "";
  let months = (now.getFullYear() - p.y) * 12 + (now.getMonth() + 1 - p.m);
  if (now.getDate() < p.d) months -= 1;
  if (months < 0) return "";
  const years = Math.floor(months / 12);
  return years >= 1 ? `${years} yrs` : `${months} mo`;
};

/** True when the date of birth cannot be right: in the future, or the member would be under 10. Missing dates are not flagged. */
export const dobLooksWrong = (value, now = new Date()) => {
  const p = toParts(value);
  if (!p) return false;
  let months = (now.getFullYear() - p.y) * 12 + (now.getMonth() + 1 - p.m);
  if (now.getDate() < p.d) months -= 1;
  return months < 120;
};

/** The date as given, followed by the age: "18-11-2001 · 24 yrs". Just the date when no age can be worked out. */
export const dobWithAge = (value) => {
  const age = formatAge(value);
  return age ? `${value} · ${age}` : value;
};

/** Text for a date of birth that was typed or picked wrongly: half-typed, impossible, or a year that cannot be right. "" when fine or empty. */
export const dobTypedProblem = (value, now = new Date()) => {
  if (!value) return "";
  if (typeof value === "object" && typeof value.isValid === "function" && !value.isValid()) {
    return "Enter a full valid date as DD/MM/YYYY";
  }
  const p = toParts(value);
  if (!p) return "";
  if (p.y < now.getFullYear() - 100) return "Check the year: member would be over 100";
  return "";
};
